import type { ReactNode } from "react";

import { NotFoundPage } from "../pages/NotFoundPage";
import { useSession } from "./session-context";

/**
 * Owner-only pages (section 6.2). This only shapes the UI: the API enforces
 * the same rule in its service layer, so hiding a page is never the protection.
 */
export function RequireOwner({ children }: { children: ReactNode }) {
  const { me } = useSession();
  return me.role === "owner" ? children : <NotFoundPage />;
}
